// ============================================
// LIGA AJUPAM - Direcciones del sorteo en sede (v6.11.372)
// ============================================
// Lógica pura (sin React, sin Supabase) de las rutas del sorteo, para poder probarla con un script de Node:
//   /sorteo/<código>      el jugador se anota (es lo que lleva el QR del cartel)
//   /sorteo/<código>/qr   pantalla para el PERSONAL del predio: muestra el QR bien grande en el celular
// El código del sorteo no es un secreto (va impreso en los carteles); lo que protege el sorteo es el servidor.

const CODE = '[A-Za-z0-9]{4,32}';
const JOIN_RE = new RegExp(`^/sorteo/(${CODE})/?$`);
const QR_RE = new RegExp(`^/sorteo/(${CODE})/qr/?$`);

const defaultOrigin = (): string => (typeof window !== 'undefined' ? window.location.origin : '');

/** URL que va dentro del QR (la que escanea el jugador). */
export const raffleJoinUrl = (joinCode: string, origin: string = defaultOrigin()): string =>
  `${origin}/sorteo/${encodeURIComponent(joinCode)}`;

/** URL de la pantalla con el QR grande, para que el personal la abra en su celular. */
export const raffleQrScreenUrl = (joinCode: string, origin: string = defaultOrigin()): string =>
  `${raffleJoinUrl(joinCode, origin)}/qr`;

/** Saca el código de `/sorteo/<código>`; `null` si no es esa ruta (incluida la del QR grande). */
export const parseRaffleJoinPath = (pathname: string): string | null => {
  const m = pathname.match(JOIN_RE);
  return m ? m[1].toUpperCase() : null;
};

/** Saca el código de `/sorteo/<código>/qr`; `null` si no es esa ruta. */
export const parseRaffleQrPath = (pathname: string): string | null => {
  const m = pathname.match(QR_RE);
  return m ? m[1].toUpperCase() : null;
};

/** Texto para mandarle al personal por WhatsApp. */
export const raffleStaffShareText = (title: string, qrScreenUrl: string): string =>
  `${title}: abrí este link en tu celular y mostrales el QR a los jugadores para que se anoten en el sorteo.\n${qrScreenUrl}`;

/** Link de WhatsApp con el texto ya escrito (sin número: la persona elige a quién). */
export const whatsappShareUrl = (text: string): string => `https://wa.me/?text=${encodeURIComponent(text)}`;
